import {
  CONDITION,
  type Conditions,
  type Item,
  PROMOTION_TYPE,
  Restrictions,
} from 'typings'
import { SCOPE_OPTIONS } from '../Form/ItemsView/typing'
import type { PromotionBase } from './promotion'

export type BuyTogetherConditions = Pick<
  Conditions,
  | CONDITION.BIN
  | CONDITION.CLUSTER
  | CONDITION.ORDER_VALUE
  | CONDITION.PAYMENT_METHODS
  | CONDITION.UTM
>

export interface BuyTogetherTrigger {
  [SCOPE_OPTIONS.SKUS]: Item[]
  minQuantity: number
  discount: number
}

export interface BuyTogetherBenefit {
  [SCOPE_OPTIONS.SKUS]: Item[]
  discount: number
}
export interface BuyTogetherEffect {
  trigger: BuyTogetherTrigger | undefined
  benefit: BuyTogetherBenefit | undefined
}

export type BuyTogetherRestrictions = Omit<
  Restrictions,
  'maxItemsPerAttribute' | 'maxItemsPerCart'
>

export interface BuyTogetherPromotion extends PromotionBase {
  type: PROMOTION_TYPE.BUY_TOGETHER
  buyTogether: BuyTogetherEffect
  conditions: BuyTogetherConditions
  restrictions: BuyTogetherRestrictions
}
